import { render, staticRenderFns } from "./data-table.component.vue?vue&type=template&id=4480a6f0&scoped=true"
import script from "./data-table.component.vue?vue&type=script&lang=ts"
export * from "./data-table.component.vue?vue&type=script&lang=ts"
import style0 from "./data-table.component.vue?vue&type=style&index=0&id=4480a6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480a6f0",
  null
  
)

export default component.exports